function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["collapsed", "type", "header", "enableToggle", "onCollapsed"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useRTL } from "../../../hooks/useRTL";
import { cn } from "../../../lib/utils";
import { ArrowchevronDownIcon, ArrowchevronLeftIcon, ArrowchevronRightIcon, ArrowchevronUpIcon, PutawayIcon, PutawayLeftIcon } from '@bfe/moly-icons';
import RcMenu from 'rc-menu';
import { useMemo, useState } from 'react';
import { injectFullMenuStyles } from "./style";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
injectFullMenuStyles();
var useCollapse = function useCollapse(changeCollapsed) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    collapsed = _useState2[0],
    setCollapsed = _useState2[1];
  var toggle = function toggle() {
    setCollapsed(!collapsed);
    changeCollapsed === null || changeCollapsed === void 0 || changeCollapsed(!collapsed);
  };
  return {
    collapsed: collapsed,
    toggle: toggle,
    setCollapsed: setCollapsed
  };
};
export var Menu = function Menu(props) {
  var _ref = props || {},
    collapsed = _ref.collapsed,
    type = _ref.type,
    header = _ref.header,
    enableToggle = _ref.enableToggle,
    onCollapsed = _ref.onCollapsed,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var isRTLFromUse = useRTL();
  var isRTL = useMemo(function () {
    var htmlNode = document.querySelector('html');
    var isRTLFromHtmlDir = htmlNode === null || htmlNode === void 0 ? void 0 : htmlNode.getAttribute('dir');
    var isRTLFromHtmlDataDirection = htmlNode === null || htmlNode === void 0 ? void 0 : htmlNode.getAttribute('data-direction');
    return isRTLFromUse || isRTLFromHtmlDir === 'rtl' || isRTLFromHtmlDataDirection === 'rtl';
  }, [isRTLFromUse]);
  var collapsedState = useCollapse(onCollapsed);
  var isCollapsed = collapsed || collapsedState.collapsed;
  var getLabel = function getLabel(item) {
    if (item !== null && item !== void 0 && item.icon) {
      if (isCollapsed) {
        return /*#__PURE__*/_jsx("span", {
          className: "moly-menu-label",
          children: item === null || item === void 0 ? void 0 : item.icon
        });
      }
      return /*#__PURE__*/_jsxs("span", {
        className: "moly-menu-label",
        children: [item === null || item === void 0 ? void 0 : item.icon, /*#__PURE__*/_jsx("span", {
          children: item === null || item === void 0 ? void 0 : item.label
        })]
      });
    }
    return /*#__PURE__*/_jsx("span", {
      className: "moly-menu-label",
      children: item === null || item === void 0 ? void 0 : item.label
    });
  };
  var getCollapsedItems = function getCollapsedItems(items) {
    var res = [];
    (items || []).forEach(function (item) {
      if (item.type === 'divider') {
        return;
      }
      if (item.type === 'group') {
        var children = getCollapsedItems(item.children || []);
        res.push.apply(res, _toConsumableArray(children));
        return;
      }
      res.push(_objectSpread(_objectSpread({}, item), {}, {
        label: getLabel(item)
      }));
    });
    return res;
  };
  var getItems = function getItems(items) {
    return (items || []).map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        label: getLabel(item)
      });
    });
  };

  // items
  var newItems = isCollapsed ? getCollapsedItems(props.items || []) : getItems(props.items || []);

  // collapse
  var normalExpandIcon = function normalExpandIcon(props) {
    return props.isOpen ? /*#__PURE__*/_jsx(ArrowchevronUpIcon, {
      className: "moly-menu-icon-arrow"
    }) : /*#__PURE__*/_jsx(ArrowchevronDownIcon, {
      className: "moly-menu-icon-arrow"
    });
  };
  var rootKeys = (props.items || []).map(function (item) {
    return item.key;
  });
  var collapseExpandIcon = function collapseExpandIcon(props) {
    var isRoot = rootKeys.includes(props === null || props === void 0 ? void 0 : props.eventKey);
    return !isRoot ? isRTL ? /*#__PURE__*/_jsx(ArrowchevronLeftIcon, {}) : /*#__PURE__*/_jsx(ArrowchevronRightIcon, {}) : null;
  };
  // style
  var mixedProps = _objectSpread(_objectSpread({}, otherProps), {}, {
    items: newItems,
    mode: isCollapsed ? 'vertical' : 'inline',
    prefixCls: 'moly-menu',
    inlineIndent: 20,
    // 按照二级菜单的左侧间距设置，然后通过样式把一级菜单的左侧间距设置为：padding: 12px !important
    expandIcon: isCollapsed ? collapseExpandIcon : normalExpandIcon,
    direction: isRTL ? 'rtl' : 'ltr',
    builtinPlacements: {
      rightTop: {
        points: isRTL ? ['tr', 'tl'] : ['tl', 'tr'],
        offset: isRTL ? [-8, 6] : [8, 6]
      }
    }
  });
  // card, fixed
  var isCard = type === 'card';
  var containerCls = cn({
    'moly-menu-wrapper-collapsed': isCollapsed,
    'moly-menu-wrapper': !isCollapsed,
    'moly-menu-card': isCard && !isCollapsed,
    'moly-menu-fixed': !isCard && !isCollapsed
  });
  var toggleCaret = /*#__PURE__*/_jsx("div", {
    className: "moly-menu-action",
    onClick: collapsedState.toggle,
    children: /*#__PURE__*/_jsx("span", {
      className: "moly-menu-collapsed-button",
      children: isCollapsed ? /*#__PURE__*/_jsx(PutawayIcon, {
        style: {
          width: '16px',
          height: '16px'
        }
      }) : /*#__PURE__*/_jsx(PutawayLeftIcon, {
        style: {
          width: '16px',
          height: '16px'
        }
      })
    })
  });
  return /*#__PURE__*/_jsxs("div", {
    className: containerCls,
    children: [/*#__PURE__*/_jsx("div", {
      className: "moly-menu-header",
      children: enableToggle ? toggleCaret : header
    }), /*#__PURE__*/_jsx(RcMenu, _objectSpread({}, mixedProps))]
  });
};
export default Menu;